import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
const SUPABASE_TIMEOUT_MS = Number(process.env.REACT_APP_SUPABASE_TIMEOUT_MS || 20000);

function supabaseFetch(input, init = {}) {
  const nativeFetch = globalThis.fetch;
  if (typeof nativeFetch !== 'function') {
    return Promise.reject(new Error('Fetch is unavailable'));
  }

  const controller = new AbortController();
  const upstreamSignal = init.signal;
  let timedOut = false;
  const timeoutId = setTimeout(() => {
    timedOut = true;
    controller.abort();
  }, SUPABASE_TIMEOUT_MS);
  const abortFromUpstream = () => controller.abort();

  if (upstreamSignal) {
    if (upstreamSignal.aborted) controller.abort();
    else upstreamSignal.addEventListener('abort', abortFromUpstream, { once: true });
  }

  return nativeFetch(input, { ...init, signal: controller.signal })
    .catch(error => {
      if (error?.name === 'AbortError' && timedOut) {
        throw new Error(`Supabase request timed out after ${Math.round(SUPABASE_TIMEOUT_MS / 1000)}s`);
      }
      throw error;
    })
    .finally(() => {
      clearTimeout(timeoutId);
      upstreamSignal?.removeEventListener?.('abort', abortFromUpstream);
    });
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  // Keep a legitimate bounded request from being preempted by the SDK default 5s lock takeover.
  auth: { lockAcquireTimeout: Math.max(30000, SUPABASE_TIMEOUT_MS + 10000) },
  global: {
    fetch: supabaseFetch,
  },
});
